import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAccessToken, selectSwitcher, selectUserType } from '../../../redux/selectors';
import SupportMenu from '../../QaPage/SupportMenu/SupportMenu';
import { getChatqaResultStatisticsThunk } from '../../../redux/qa/qaActions';
import { selectChatqaResultStatistics } from '../../../redux/selectors';
import {
  AgentStatMainConatiner,
  AgentStatMainText,
  AgentStatMainTextSpan,
  AgentStatInfoContainer,
  LeftInfoCon,
  LeftInfoTopCon,
  LeftInfoCenterCon,
  LeftInfoConSmall,
  LeftInfoConSmallNumber,
  LeftInfoConSmallNumberGreen,
  LeftInfoConSmallText,
  RightInfoCon,
  RightInfoTopCon,
  RightInfoCenterCon,
  RightInfoTopConItem,
  RightInfoTopConText,
  GreenIcon,
  TableContainer,
  Table,
  Th,
  Td,
  Tr,
  Tag,
  PaginationContainer,
  PaginationButton,
} from '../../QaPage/AgentStat/AgentStat.styled';
import { Cell, Label, Pie, PieChart, Tooltip } from 'recharts';
import { getPersonalQaStatistics, getQaOperatorsAssignments } from '../../../services/API';
import {
  QaAgentsStatisticConteiner,
  StatNumber,
  Table as QaTable,
  TableRow as QaTableRow,
  Td as QaTd,
  Th as QaTh,
} from '../../QaPage/QaAgentsStatistic/QaAgentsStatistic.styled';
import { LoaderPay } from 'components/PaymentBotStat/PaymentBotStat.styled';
import { Link } from 'react-router-dom';

// Компонент для отображения статистики QA для руководителей
const QaStatisticsForLeaders = ({ year, month, isChecked, onYearChange, onMonthChange, onCheckedChange, qaStat, isLoading }) => {
  const [loading, setLoading] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'desc',
  });
  const [selectedColumn, setSelectedColumn] = useState('total_chats');
  const [filterValue, setFilterValue] = useState('');
  // --- добавлено для селекта supervisor ---
  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState('');
  const token = useSelector(selectAccessToken);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSupervisors = async () => {
      if (!token) return;
      try {
        const data = await getQaOperatorsAssignments(token);
        setSupervisors(data);
      } catch (e) {
        setSupervisors([]);
      }
    };
    fetchSupervisors();
  }, [token]);

  // Новый useEffect для group_id
  useEffect(() => {
    let groupId;
    if (selectedSupervisor) {
      const found = supervisors.find(item => item.supervisor_username === selectedSupervisor);
      groupId = found ? found.id : undefined;
    }
    if (selectedSupervisor && groupId) {
      dispatch(
        getChatqaResultStatisticsThunk({
          token,
          year,
          month,
          checked: isChecked ? '1' : '0',
          group_id: groupId,
        })
      );
    } else if (!selectedSupervisor) {
      dispatch(
        getChatqaResultStatisticsThunk({
          token,
          year,
          month,
          checked: isChecked ? '1' : '0',
        })
      );
    }
  }, [selectedSupervisor, token, year, month, isChecked, dispatch, supervisors]);

  useEffect(() => {
    console.log('qaStat received:', qaStat);
    if (Array.isArray(qaStat?.agents)) {
      console.log('Setting agents data:', qaStat.agents);
      setSortedData([...qaStat.agents]);
      setLoading(false);
    } else if (Array.isArray(qaStat?.data)) {
      console.log('Setting data:', qaStat.data);
      setSortedData([...qaStat.data]);
      setLoading(false);
    } else {
      console.log('No data found, setting empty array');
      setSortedData([]);
      setLoading(false);
    }
  }, [qaStat]);

  const handleSort = key => {
    let direction = 'desc';
    if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = 'asc';
    }
    setSortConfig({ key, direction });
    const sortedArray = [...sortedData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setSortedData(sortedArray);
  };

  const filteredData = sortedData.filter(user =>
    filterValue ? user[selectedColumn] >= Number(filterValue) : true
  );

  const formatDateTime = rawDate => {
    const date = new Date(rawDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  };

  const columnNames = {
    total_chats: 'Всего чатов',
    total_checked: 'Проверено',
    grade: 'Оценка',
  };

  return (
    <QaAgentsStatisticConteiner>
      <div style={{ marginBottom: '20px' }}>
        <label style={{ marginRight: '10px' }}>
          Год:
          <input
            type="number"
            value={year}
            onChange={e => {
              const value = e.target.value.replace(/\D/g, '');
              onYearChange(value);
            }}
            onKeyDown={e => {
              if (e.key === 'e' || e.key === '+' || e.key === '-') {
                e.preventDefault();
              }
            }}
            min="2020"
            max="2050"
            style={{ marginLeft: '10px' }}
            pattern="\d*"
          />
        </label>

        <label style={{ marginRight: '10px' }}>
          Месяц:
          <input
            type="number"
            value={month}
            onChange={e => {
              const value = e.target.value.replace(/\D/g, '');
              onMonthChange(value);
            }}
            onKeyDown={e => {
              if (e.key === 'e' || e.key === '+' || e.key === '-') {
                e.preventDefault();
              }
            }}
            min="1"
            max="12"
            style={{ marginLeft: '10px' }}
            pattern="\d*"
          />
        </label>

        <label style={{ marginRight: '10px' }}>
          Проверенно:
          <input
            type="checkbox"
            checked={isChecked}
            onChange={e => onCheckedChange(e.target.checked)}
            style={{ marginLeft: '10px' }}
          />
        </label>

        {qaStat?.last_update && (
          <label style={{ marginRight: '10px' }}>
            Последнее обновление: {formatDateTime(qaStat.last_update)}
          </label>
        )}
        {/* --- Селект supervisor_username --- */}
        {supervisors.length > 0 && (
          <label style={{ marginLeft: '10px' }}>
            Супервайзер:
            <select
              value={selectedSupervisor}
              onChange={e => setSelectedSupervisor(e.target.value)}
              style={{ marginLeft: '10px' }}
            >
              <option value="">-</option>
              {supervisors.map((item, idx) => (
                <option key={idx} value={item.supervisor_username}>
                  {item.supervisor_username}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>

      {/* Блок агрегированной информации */}
      {qaStat?.aggregate && (
        <AgentStatInfoContainer>
          <LeftInfoCon>
            <LeftInfoTopCon>Общая статистика</LeftInfoTopCon>
            <LeftInfoCenterCon>
              <LeftInfoConSmall>
                <LeftInfoConSmallNumber>
                  {qaStat.aggregate.count_chats}
                </LeftInfoConSmallNumber>
                <LeftInfoConSmallText>Проверено чатов</LeftInfoConSmallText>
              </LeftInfoConSmall>
              <LeftInfoConSmall>
                <LeftInfoConSmallNumberGreen>
                  {qaStat.aggregate.average_score?.toFixed(1)}
                </LeftInfoConSmallNumberGreen>
                <LeftInfoConSmallText>Средняя оценка</LeftInfoConSmallText>
              </LeftInfoConSmall>
              <LeftInfoConSmall>
                <LeftInfoConSmallNumber>
                  {qaStat.aggregate.count_errors}
                </LeftInfoConSmallNumber>
                <LeftInfoConSmallText>Найдено ошибок</LeftInfoConSmallText>
              </LeftInfoConSmall>
            </LeftInfoCenterCon>
          </LeftInfoCon>

          {qaStat.aggregate.top_tags && qaStat.aggregate.top_tags.length > 0 && (
            <>
              <PieChart width={250} height={250}>
                <Pie
                  data={qaStat.aggregate.top_tags}
                  dataKey="count"
                  nameKey="tag"
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  style={{ outline: 'none' }}
                >
                  {qaStat.aggregate.top_tags.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry?.color} />
                  ))}
                  <Label position="center" content={() => 'Топ проблемы'} />
                </Pie>
                <Tooltip formatter={(value, name) => [value, name]} />
              </PieChart>
              
              <RightInfoCon>
                <RightInfoTopCon>Топ 5 ошибок</RightInfoTopCon>
                <RightInfoCenterCon>
                  {qaStat.aggregate.top_tags.slice(0, 5).map((tag, index) => (
                    <RightInfoTopConItem key={index}>
                      <GreenIcon style={{ background: tag?.color }} />
                      <RightInfoTopConText>{tag.tag}</RightInfoTopConText>
                    </RightInfoTopConItem>
                  ))}
                </RightInfoCenterCon>
              </RightInfoCon>
            </>
          )}
        </AgentStatInfoContainer>
      )}

      {/* Блок top_questions */}
      {qaStat?.aggregate?.top_questions && qaStat.aggregate.top_questions.length > 0 && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10px',
          marginTop: '30px',
          marginBottom: '30px'
        }}>
          {qaStat.aggregate.top_questions.map(
            ({ question_id, question__text, violations }) => (
              <div
                key={question_id}
                style={{
                  padding: '10px',
                  border: '2px solid #ae8cff',
                  borderRadius: '5px',
                  background: '#fff',
                }}
              >
                {question__text}: <strong>{violations}</strong>
              </div>
            )
          )}
        </div>
      )}

      {qaStat && (qaStat?.agents?.length > 0 || qaStat?.data?.length > 0 || sortedData.length > 0) ? (
        <>
          <div style={{ marginBottom: '20px' }}>
            {[
              'total_chats',
              'total_checked', 
              'grade',
            ].map(column => (
              <label key={column} style={{ marginRight: '10px' }}>
                <input
                  type="radio"
                  name="columnSelector"
                  checked={selectedColumn === column}
                  onChange={() => setSelectedColumn(column)}
                  style={{ marginRight: '5px' }}
                />
                {columnNames[column]}
              </label>
            ))}
            <input
              type="text"
              placeholder="Введите значение"
              value={filterValue}
              onChange={e => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setFilterValue(value);
                }
              }}
              onKeyDown={e => {
                if (e.key === '-' || e.key === '+' || e.key === 'e') {
                  e.preventDefault();
                }
              }}
              pattern="\d*"
            />
          </div>

          {loading || isLoading ? (
            <LoaderPay />
          ) : (
            <div style={{ marginBottom: '50px' }}>
              <div style={{ marginBottom: '10px', fontSize: '12px', color: '#666' }}>
                Отладочная информация: {sortedData.length} записей, qaStat.agents: {qaStat?.agents?.length || 0}, loading: {loading}, isLoading: {isLoading}
              </div>
            <QaTable>
              <thead>
                <tr>
                  <QaTh onClick={() => handleSort('agents__name')}>Агент</QaTh>
                  <QaTh onClick={() => handleSort('total_chats')}>Всего чатов</QaTh>
                  <QaTh onClick={() => handleSort('total_checked')}>Проверено</QaTh>
                  <QaTh onClick={() => handleSort('grade')}>Оценка</QaTh>
                  <QaTh onClick={() => handleSort('head')}>Руководитель</QaTh>
                  <QaTh onClick={() => handleSort('comment')}>Комментарий</QaTh>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((user, index) => (
                  <QaTableRow key={index}>
                  {console.log('user', user)}
                    <QaTd>
                      <Link
                        to={`/userStat/${user.agents__id}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {user.agents__name}
                      </Link>
                    </QaTd>
                    <QaTd>{user.total_chats}</QaTd>
                    <QaTd>{user.total_checked}</QaTd>
                    <QaTd>
                      <StatNumber style={{
                        color: user.grade >= 90 ? 'green' : user.grade >= 80 ? 'orange' : 'red'
                      }}>
                        {user.grade}
                      </StatNumber>
                    </QaTd>
                    <QaTd>{user.head || 'Не указан'}</QaTd>
                    <QaTd style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {user.comment || 'Нет комментария'}
                    </QaTd>
                  </QaTableRow>
                ))}
              </tbody>
            </QaTable>
            </div>
          )}
        </>
      ) : null}
    </QaAgentsStatisticConteiner>
  );
};

const Personal_stat = () => {
  const [personalStats, setPersonalStats] = useState(null);
  const [personalChats, setPersonalChats] = useState(null);
  const [personalResultStats, setPersonalResultStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedChat, setSelectedChat] = useState(null);
  const menuRef = useRef(null);
  const token = useSelector(selectAccessToken);
  const switcher = useSelector(selectSwitcher);
  const userType = useSelector(selectUserType);
  const dispatch = useDispatch();
  
  // Состояния для статистики QA (для руководителей)
  const [isChecked, setIsChecked] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [month, setMonth] = useState((new Date().getMonth() + 1).toString());
  const qaStat = useSelector(selectChatqaResultStatistics);
  const [qaLoading, setQaLoading] = useState(false);

  const getFormattedDate = date => {
    return date.toISOString().split('T')[0];
  };

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 7); // Берем неделю назад

  const [startDate, setStartDate] = useState(getFormattedDate(yesterday));
  const [endDate, setEndDate] = useState(getFormattedDate(today));

  const fetchPersonalStats = async () => {
    if (!token) {
      setError('Токен доступа отсутствует');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Запрос основной статистики reviewed-chats/personal
      const statsResponse = await fetch(`https://cat-tools.com/api/chatqa/reviewed-chats/personal?created_at_after=${startDate}&created_at_before=${endDate}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!statsResponse.ok) {
        throw new Error(`Ошибка запроса статистики: ${statsResponse.status} ${statsResponse.statusText}`);
      }

      const statsData = await statsResponse.json();
      console.log('Personal stats получены:', statsData);

      // Запрос статистики result/statistics
      try {
        const resultStatsData = await getPersonalQaStatistics(token, startDate, endDate);
        console.log('Personal result statistics получены:', resultStatsData);
        // Оборачиваем в массив если это не массив для единообразия
        setPersonalResultStats(Array.isArray(resultStatsData) ? resultStatsData : [resultStatsData]);
      } catch (resultError) {
        console.warn('Ошибка при получении result statistics:', resultError);
        setPersonalResultStats(null);
      }

      // Запрос чатов с пагинацией
      const chatsResponse = await fetch(`https://cat-tools.com/api/chatqa/reviewed-chats/personal?created_at_after=${startDate}&created_at_before=${endDate}&page=${currentPage}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!chatsResponse.ok) {
        throw new Error(`Ошибка запроса чатов: ${chatsResponse.status} ${chatsResponse.statusText}`);
      }

      const chatsData = await chatsResponse.json();
      console.log('Personal chats получены:', chatsData);

      // Оборачиваем данные в массив для совместимости с AgentStat логикой
      setPersonalStats(statsData ? [statsData] : []);
      setPersonalChats(chatsData);
    } catch (error) {
      console.error('Ошибка при получении personal stats:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Загружаем личную статистику только для обычных пользователей
    if (!(userType === 'tl' || userType === 'head' || userType === 'supervisor')) {
      fetchPersonalStats();
    }
  }, [token, startDate, endDate, currentPage, userType]);

  // Загружаем статистику QA для руководителей
  useEffect(() => {
    if ((userType === 'tl' || userType === 'head' || userType === 'supervisor') && token) {
      console.log('Dispatching QA statistics request for leaders');
      setQaLoading(true);
      dispatch(
        getChatqaResultStatisticsThunk({
          token,
          year,
          month,
          checked: isChecked ? '1' : '0',
        })
      ).then(() => {
        setQaLoading(false);
      }).catch(() => {
        setQaLoading(false);
      });
    }
  }, [dispatch, token, year, month, isChecked, userType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setSelectedChat(null);
      }
    };

    if (selectedChat) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedChat]);

  const handleStartDateChange = e => {
    setStartDate(e.target.value);
    setCurrentPage(1); // Сбрасываем страницу при изменении фильтра
  };

  const handleEndDateChange = e => {
    setEndDate(e.target.value);
    setCurrentPage(1); // Сбрасываем страницу при изменении фильтра
  };

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };

  const formatDate = isoString => {
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = String(date.getUTCFullYear());
    return `${day}.${month}.${year}`;
  };

  const formatTimeVerbose = timeString => {
    if (!timeString) return 'N/A';
    const [, minutes, seconds] = timeString.split(':');
    return `${parseInt(minutes, 10)} мин ${parseInt(seconds, 10)} сек`;
  };

  const handleChatSelect = (chat) => {
    console.log('Selected chat:', chat);
    setSelectedChat(chat);
  };

  // Если пользователь имеет тип "tl", "head" или "supervisor", показываем статистику QA
  if (userType === 'tl' || userType === 'head' || userType === 'supervisor') {
    return (
      <div style={{ padding: '20px' }}>
        <QaStatisticsForLeaders
          year={year}
          month={month}
          isChecked={isChecked}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onCheckedChange={setIsChecked}
          qaStat={qaStat}
          isLoading={qaLoading}
        />
      </div>
    );
  }

  // Для обычных пользователей показываем состояние загрузки
  if (loading) {
    return (
      <AgentStatMainConatiner>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          Загрузка данных...
        </div>
      </AgentStatMainConatiner>
    );
  }

  // Для обычных пользователей показываем ошибки
  if (error) {
    return (
      <AgentStatMainConatiner>
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          color: '#dc2626',
          backgroundColor: '#fef2f2',
          borderRadius: '8px',
          border: '1px solid #fca5a5'
        }}>
          <strong>Ошибка:</strong> {error}
        </div>
      </AgentStatMainConatiner>
    );
  }

  // Если пользователь имеет тип "tl", "head" или "supervisor", показываем статистику QA
  if (userType === 'tl' || userType === 'head' || userType === 'supervisor') {
    console.log('Rendering QA statistics for leaders, qaStat:', qaStat);
    return (
      <div style={{ padding: '20px' }}>
        <h2 style={{ marginBottom: '20px', color: '#333' }}>
          Статистика QA для руководителей
        </h2>
        
        <QaStatisticsForLeaders
          year={year}
          month={month}
          isChecked={isChecked}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onCheckedChange={setIsChecked}
          qaStat={qaStat}
          isLoading={qaLoading}
        />
      </div>
    );
  }

  // Для остальных типов пользователей показываем стандартную личную статистику
  return (
    <>
      {personalStats?.map(item => (
        <AgentStatMainConatiner key={item?.id || 'personal'}>
          <AgentStatMainText>
            Личная статистика проверенных чатов
          </AgentStatMainText>
          
          <div style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '20px',
            marginTop: '20px',
          }}>
            <label>
              С:
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                style={{ marginLeft: '10px' }}
              />
            </label>
            <label>
              По:
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                style={{ marginLeft: '10px' }}
              />
            </label>
          </div>

          <AgentStatInfoContainer>
            {/* Используем данные из personalResultStats если они есть, иначе из personalStats */}
            {(personalResultStats?.[0]?.total_chats !== null || item?.total_chats !== null) ? (
              <LeftInfoCon>
                <LeftInfoTopCon>Карта качества</LeftInfoTopCon>
                <LeftInfoCenterCon>
                  <LeftInfoConSmall>
                    <LeftInfoConSmallNumber>
                      {personalResultStats?.[0]?.total_chats ?? item?.total_chats}
                    </LeftInfoConSmallNumber>
                    <LeftInfoConSmallText>Проверено чатов</LeftInfoConSmallText>
                  </LeftInfoConSmall>
                  <LeftInfoConSmall>
                    <LeftInfoConSmallNumberGreen>
                      {personalResultStats?.[0]?.grade ?? item?.grade}
                    </LeftInfoConSmallNumberGreen>
                    <LeftInfoConSmallText>Средняя оценка</LeftInfoConSmallText>
                  </LeftInfoConSmall>
                  <LeftInfoConSmall>
                    <LeftInfoConSmallNumber>
                      {personalResultStats?.[0]?.total_issues ?? item?.total_issues}
                    </LeftInfoConSmallNumber>
                    <LeftInfoConSmallText>Найдено ошибок</LeftInfoConSmallText>
                  </LeftInfoConSmall>
                </LeftInfoCenterCon>
              </LeftInfoCon>
            ) : (
              <></>
            )}

            {/* Используем данные из personalResultStats если они есть, иначе из personalStats */}
            {(personalResultStats?.[0]?.top_issues || item?.top_issues) ? (
              <>
                {' '}
                <PieChart width={250} height={250}>
                  <Pie
                    data={personalResultStats?.[0]?.top_issues ?? item?.top_issues}
                    dataKey="count"
                    nameKey="tag"
                    cx="50%"
                    cy="50%"
                    outerRadius={100}
                    fill="#8884d8"
                    style={{ outline: 'none' }}
                  >
                    {(personalResultStats?.[0]?.top_issues ?? item?.top_issues)?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry?.color} />
                    ))}
                    <Label position="center" content={() => 'Топ проблемы'} />
                  </Pie>
                  <Tooltip formatter={(value, name) => [value, name]} />
                </PieChart>
                <RightInfoCon>
                  <RightInfoTopCon>Топ 5 ошибок</RightInfoTopCon>
                  <RightInfoCenterCon>
                    {(personalResultStats?.[0]?.top_issues ?? item?.top_issues)?.map((issue, index) => (
                      <RightInfoTopConItem key={index}>
                        <GreenIcon style={{ background: issue?.color }} />
                        <RightInfoTopConText>{issue.tag}</RightInfoTopConText>
                      </RightInfoTopConItem>
                    ))}
                  </RightInfoCenterCon>
                </RightInfoCon>
              </>
            ) : (
              <></>
            )}
          </AgentStatInfoContainer>

          {console.log('personalStats:', personalStats[0])}
          {console.log('personalResultStats:', personalResultStats)}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px',
            marginTop: '50px'
          }}>
            {/* Используем данные из personalResultStats если они есть, иначе из personalStats */}
            {(personalResultStats?.[0]?.violated_questions ?? personalStats[0]?.violated_questions)?.map(
              ({ question_id, question_text, violations }) => (
                <div
                  key={question_id}
                  style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    background: '#fff',
                    border: '2px solid #ae8cff'
                  }}
                >
                    {console.log()}
                  {question_text}: <strong>{violations}</strong>
                </div>
              )
            )}
          </div>

          {personalChats?.results?.length !== 0 ? (
            <>
              <TableContainer>
                <Table>
                  <thead>
                    <tr>
                      <Th>Дата</Th>
                      <Th>Неделя</Th>
                      <Th>Тег ошибок</Th>
                      <Th>Длина</Th>
                      <Th>Балл</Th>
                      <Th>Комментарий</Th>
                    </tr>
                  </thead>
                  <tbody>
                    {personalChats?.results?.map((row, index) => (
                      <Tr 
                        key={index}
                        onClick={() => handleChatSelect(row)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Td>{formatDate(row.created_at)}</Td>
                        <Td>{row.week} неделя</Td>
                        <Td style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '5px',
                        }}>
                          {row?.tags?.map((tag, i) => (
                            <Tag key={i}>{tag}</Tag>
                          ))}
                        </Td>
                        <Td>{formatTimeVerbose(row?.chat_duration)}</Td>
                        <Td>{row?.score}</Td>
                        <Td>{row?.comment}</Td>
                      </Tr>
                    ))}
                  </tbody>
                </Table>
              </TableContainer>

              {/* Добавляем пагинацию */}
              <PaginationContainer>
                {personalChats?.previous !== null ? (
                  <PaginationButton
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    {'<'}
                  </PaginationButton>
                ) : (
                  <></>
                )}
                {personalChats?.next !== null ? (
                  <PaginationButton
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    {'>'}
                  </PaginationButton>
                ) : (
                  <></>
                )}
              </PaginationContainer>
            </>
          ) : (
            <></>
          )}

          {selectedChat && (
            <SupportMenu 
              userId={selectedChat.pk} 
              chats={[selectedChat]}
              switcher={switcher}
              onClose={() => setSelectedChat(null)}
            />
          )}
        </AgentStatMainConatiner>
      ))}
    </>
  );
};

export default Personal_stat;
